module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "ui-checklist"
  }, [_c('h4', {
    staticClass: "ui-checklist-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('ul', _vm._l((_vm.items), function(item) {
    return _c('li', {
      staticClass: "ui-checklist-checkbox"
    }, [_c('label', {
      staticClass: "ui-checklist-checkbox--label"
    }, [_c('input', {
      staticClass: "ui-checklist-checkbox--box",
      attrs: {
        "type": "checkbox"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "ui-checklist-checkbox--title"
    }, [_vm._v(_vm._s(item))])])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-461e57c1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/universal/UiChecklist.vue
// module id = 443
// module chunks = 1